import { Redeem } from '@material-ui/icons';
import { RouteProps } from 'react-router';
import Redemption from '.';
import redemptionMain from './redemption-main';
import RedeemOtp from './RedeemOtp';
import RedemptionSuccess from './redemption-success';

export const RedeemPaths = {
    RedeemOtp: '/redeem/verify-otp',
    RedeemSucces: '/redeem/success',
    Redeem: '/redemption',
    RedeemMain: '/redemption/:isin',
};

const routes: RouteProps[] = [
    {
        path: RedeemPaths.Redeem,
        component: Redemption,
        exact: true,
    },
    {
        path: RedeemPaths.RedeemMain,
        component: redemptionMain,
    },
    {
        path: RedeemPaths.RedeemOtp,
        component: RedeemOtp,
    },
    {
        path: RedeemPaths.RedeemSucces,
        component: RedemptionSuccess,
    },
];

export { routes as RedeemRoutes };
